import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useProfile(id) {
  const { token } = useUser();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchProfile() {
      setLoading(true);
      const { response, data } = await API.fetchProfile(token, id);

      if (response.ok) {
        setProfile(data);
        setLoading(false);
        setError(null);
      } else {
        setError({ status: response.status, ...data });
        setLoading(false);
      }
    }

    fetchProfile();
  }, [id, setProfile, setError, setLoading]);

  return { profile, loading, error };
}

